import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import { getAll } from '../../services/Users/Users';

// Create styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
        padding: 10,
        justifyContent: 'flex-start',
        alignItems: 'stretch',
    },
    title: {
        fontSize: 18, // Reduce el tamaño del título
        marginBottom: 15, // Reduce el margen
        textAlign: "center",
        color: "#333",
    },
    section: {
        marginBottom: 15,
        padding: 5,
        marginTop: 10,
    },
    tableTitle: {
        fontSize: 13, // Reduce el tamaño del título de la tabla
        marginBottom: 5, // Reduce el margen
        textAlign: "left",
        fontWeight: "bold",
    },
    tableSubTitle: {
        fontSize: 10, // Reduce el tamaño del subtítulo de la tabla
        marginBottom: 5, // Reduce el margen
        textAlign: "left",
        fontWeight: "bold",
    },
    table: {
        display: "table",
        width: "100%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#ddd",
        borderRadius: 5,
        overflow: "hidden",
    },
    tableRow: {
        flexDirection: "row",
    },
    tableRowEven: {
        flexDirection: "row",
        backgroundColor: "#eae7e7", // Color para filas pares
    },
    tableRowOdd: {
        flexDirection: "row",
        backgroundColor: "#ffffff", // Color para filas impares
    },
    tableColHeader: {
        flex: 1,
        minWidth: 30,
        maxWidth: 70,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#cfcfcf",
        backgroundColor: "#bcb9b9",
        padding: 2,
        fontSize: 6,
        textAlign: "center",
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
    },
    tableCol: {
        flex: 1,
        minWidth: 30,
        maxWidth: 80,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#cfcfcf",
        padding: 3,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    tableCellHeader: {
        fontSize: 8,
        fontweight: "bold",
        textAlign: "center",
        color: "black",
    },
    tableCell: {
        fontSize: 7,
        textAlign: "center",
        minHeight: "20",
        flexShrink: 1,
        whiteSpace: 'wrap',
        overflow: 'hidden',
        flex: 'auto',
    },
    
    footerRow: {
        backgroundColor: "#01579b",
        flexDirection: "row",
    },
    footerCell: {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: 7, // Ajusta el tamaño del texto en el pie de la tabla
        padding: 3, // Reduce el padding
        flex: 1,
    },
    footerCellEnd: {
        textAlign: "right",
        fontWeight: "bold",
        fontSize: 9, // Ajusta el tamaño del texto
        padding: 5, // Reduce el padding
        flex: 4,
    },
    strikethrough: {
        textDecoration: "line-through",
        color: "red",
    },
    boldText: {
        fontWeight: 'bold',
    },
    signatureSection: {
        position: "absolute",
        bottom: 40,
        left: 20,
        right: 20,
        paddingTop: 5, // Reduce el padding superior
        fontSize: 10, // Ajusta el tamaño del texto
        textAlign: "center",
    },
    date: { fontSize: 10, marginLeft: 20, paddingBottom: 3 }
});

const currentDate = new Date();
const options = { year: 'numeric', month: 'long', day: 'numeric' };
const formattedDate = currentDate.toLocaleDateString('es-ES', options);
const parts = formattedDate.split(' de ');
const finalFormat = `${parts[1]} ${parts[0]}, ${parts[2]}`;
const fileNameDate = currentDate.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-');

// Create Document Component
const MyReport = ({ data }) => {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        getAll().then(list => {
            setUsers(list);
        });
    }, []);
    return (
        <Document>
            <Page size="A4" orientation='landscape' style={styles.page}>
                <Text style={styles.title}>Reporte de Inventario</Text>
                <View style={styles.section}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Text style={styles.tableTitle}>Resumen</Text>
                        <Text style={styles.date}>{finalFormat}</Text>
                    </View>
                    {/* Espaciado para el encabezado */}
                    <View style={{ marginBottom: 10 }} />
                    <View style={styles.table}>
                        {/* Encabezado de la tabla */}
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, styles.boldText ]}>Nombre</Text></View>
                            <View style={[styles.tableColHeader, { flex: 3 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Descripción</Text></View>
                            <View style={[styles.tableColHeader, { flex: 1 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Notas Adicionales</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Fecha de adquisición</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Categoría</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Subcategoría</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Cantidad</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Ubicación</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Estado</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Costo unitario</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Asignado a</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Código de barras</Text></View>
                            <View style={[styles.tableColHeader, { flex: 3 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Número de serie</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Número de partes</Text></View>
                            <View style={[styles.tableColHeader, { flex: 3 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Etiqueta de Ident.</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Marca</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Modelo</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Dimensiones</Text></View>
                            <View style={[styles.tableColHeader, { flex: 2 }]}><Text style={[styles.tableCellHeader, { fontWeight: 'bold' }]}>Peso</Text></View>
                        </View>
                        {/* Filas de datos */}
                        {data.map((item, index) => (
                            <View style={index % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd} key={item.id}>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.name}</Text></View>
                                <View style={[styles.tableCol, { flex: 3 }]}><Text style={styles.tableCell}>{item.description}</Text></View>
                                <View style={[styles.tableCol, { flex: 1 }]}><Text style={styles.tableCell}>{item.additionalNotes}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.acquisitionDate}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.categoryName}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.subcategoryName}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.quantity}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.locationName}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.statusName}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.unitPrice}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{users.find(user => user.id === item.assignedToUserId)?.userName}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.barcode}</Text></View>
                                <View style={[styles.tableCol, { flex: 3 }]}><Text style={styles.tableCell}>{item.serialNumber}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.partNumber}</Text></View>
                                <View style={[styles.tableCol, { flex: 3 }]}><Text style={styles.tableCell} numberOfLines={5} ellipsizeMode="tail">{item.tag}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.brand}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.model}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.dimensions}</Text></View>
                                <View style={[styles.tableCol, { flex: 2 }]}><Text style={styles.tableCell}>{item.weight + item.unitOfWeightMeasurement}</Text></View>
                            </View>
                        ))}
                    </View>
                </View>
            </Page>
        </Document>
    );
};

// Componente para descargar el PDF
const PDFLink = ({ data }) => (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
        <PDFDownloadLink
            document={<MyReport data={data} />}
            fileName={`Reporte-Inventario-${fileNameDate}.pdf`}
        >
            {({ blob, url, loading, error }) =>
                loading ? "Generando documento..." : "Descargar PDF"
            }
        </PDFDownloadLink>
    </div>
);

export { PDFLink };